export default "__VITE_ASSET__CZHopFos__"